const E = {
  Required: 'Required Fields',
  EarlyShipDate: 'Required By time must be at least {{imminentGapHours}} hours from now.',
  WeekendOrHoliday: 'Required By date cannot fall on a weekend or holiday.',
  DestinationId: 'Please select the Bureau Veritas Location.',
  Comments: 'Comments',
  Criteria1: 'Criteria 1',
  Criteria2: 'Criteria 2',
  IncludeOnCofA: 'Include on CofA?',
  EmailRecipientList: 'Email Recipient List',
  InvalidEmail: 'Invalid email format. Note, only one email address can be populated in this field.',
  ImportJobToTemplate: 'Import Job to Template',
  ImportJobToTemplateOptional: 'Import Job to Template (optional)',
  JobNumberInvalid1: 'The job you have entered cannot be found in this region.',
  JobNumberInvalid2: 'Please check the job number and try again.',
  JobNumber: 'Job #',
  ImportJob: 'Import Job',
  InvoiceTo: 'Invoice To',
  CompanyName: 'Company Name',
  InvoiceAttention: 'Invoice Attention',
  ReportAttention: 'Report Attention',
  Name: 'Name',
  Phone: 'Phone',
  Email: 'Email',
  Fax: 'Fax',
  Ext: 'Ext',
  NameOrRegion: 'Name/Region',
  Contact: 'Contact',
  AfterHoursPhone: 'After Hours Phone',
  MedicalHeader: 'Medical Officer of Health/Public Health Unit',
  MaxxamLocation: 'Bureau Veritas Location',
  RequiredBy: 'Required By',
  ShippingOptions: 'Shipping Options',
  PickupLocation: 'Pickup Location',
  POAFENumber: 'PO/AFE #',
  ProjectNumber: 'Project #',
  SiteLocation: 'Site Location',
  SiteNumber: 'Site #',
  TaskOrder: 'Task Order',
  LineItem: 'Line Item',
  CostObject: 'Cost Object',
  ShelfLife: 'Storage Condition',
  RecordOfSiteCondition: 'Record of Site Condition',
  AuditSamples: 'Audit Samples',
  DataPackage: 'Data Package',
  SubmissionType: 'Submission Type',
  DeliveryAttention: 'Delivery Attention',
  Address: 'Address',
  Address2: 'Address 2',
  City: 'City',
  Province: 'Province / State',
  PostalCode: 'Postal Code / Zip Code',
  Country: 'Country',
  TitleOfTemplate: 'Title of Template',
  UnlockTemplate: 'Unlock Template',
  LockTemplate: 'Lock Template',
  WaterworksNumber: 'Waterworks #',
  WaterworksName: 'Waterworks Name',
  ProjectInformation: 'Project Information',
  ShipTo: 'Ship To',
  ReportTo: 'Report To',
  'ALSO SEND REPORT TO': 'ALSO SEND REPORT TO',
  WaterWorksTitle: 'Adverse Notification Information',
  WaterWorksInfo: 'Waterworks Information',
  'Get Info': 'Get Info',
  PONumber: 'PO Number',

  Supplies: 'Supplies',
  'Required By': 'Required By',

  ChangingSubmissionType: 'Changing the submission type will clear the sample and test information. Would you like to proceed?',
  'Pick up': 'Pick-up',
  'Deliver to Invoice Address': 'Deliver to Invoice Address',
  'Deliver to Report Address': 'Deliver to Report Address',
  'Deliver to Other': 'Deliver to Other',
  Cell: 'Cell',
  DefaultOrderLocationInvoice: 'Your default Bureau Veritas location is {{orderLocation}}',
  DefaultOrderLocationReport: 'Your default Bureau Veritas location for this Report Address is {{orderLocation}}',
  'COC #': 'COC #',
  RequestedBy: 'Requested By',
  RequestedDate: 'Requested Date',
  IsPrepaidClient: 'This is a prepaid client. Prepaid workflow has been initiated.',
  Company: 'Company',
  Facility: 'Facility',
  StreetAddress: 'Street Address',
  OverridePrepaidWorkflow: 'Override Workflow',
  CreatePrepaidJob: 'Create Prepaid Job',
  SelectShippingAddress: 'Select Shipping Address',
  SiteLocationP: 'Site Location Province',
};

const F = {
  PONumber: 'No de PO',
  'COC #': 'No CDR',
  Required: 'Champs obligatoires',
  'Pick up': 'Cueillette',
  'Deliver to Invoice Address': "Envoyez à l'adresse de facturation",
  'Deliver to Report Address': "Envoyez à l'adresse de rapport",
  'Deliver to Other': 'Envoyez à une autre adresse',
  EarlyShipDate: 'L’heure dans le champ Requis pour le doit être dans au moins {{imminentGapHours}} heures.',
  WeekendOrHoliday: 'La date dans le champ Requis pour le ne peut pas être un jour de fin de semaine ni un jour férié.',
  DestinationId: 'Veuillez sélectionner le laboratoire.',
  Comments: 'Commentaires',
  Criteria1: 'Critère 1',
  Criteria2: 'Critère 2',
  IncludeOnCofA: 'Inclure sur le certificat d’analyse ?',
  EmailRecipientList: 'Liste de destinataires',
  InvalidEmail: 'Adresse électronique invalide, Utilisez une adresse électronique valide',
  ImportJobToTemplate: 'Numéro de dossier invalide1, Importer un dossier dans le modèle (facultatif)',
  ImportJobToTemplateOptional: 'Importer le dossier dans le formulaire (facultatif)',
  JobNumberInvalid1: 'Le numéro de dossier inscrit est introuvable pour cette région.',
  JobNumberInvalid2: 'Numéro de dossier invalide2, Vérifiez le numéro de dossier et réessayez.',
  JobNumber: 'No de dossier',
  ImportJob: 'Importer le dossier',
  InvoiceTo: 'Envoyer la facture à',
  CompanyName: 'Nom de l’entreprise',
  InvoiceAttention: 'Destinaire',
  ReportAttention: 'Envoyer le rapport à',
  Name: 'Nom',
  Phone: 'Téléphone',
  Email: 'Adresse courriel',
  Fax: 'Télécopieur',
  Ext: 'Poste',
  NameOrRegion: 'Nom ou région',
  Contact: 'Contact',
  AfterHoursPhone: 'Téléphone après les heures normales',
  MedicalHeader: 'Médecin hygiéniste ou bureau de santé publique',
  MaxxamLocation: 'Laboratoire',
  RequiredBy: 'Requis pour le',
  ShippingOptions: 'Options d’expédition',
  PickupLocation: 'Lieu de ramassage',
  POAFENumber: 'No de PO ou d’AFE',
  ProjectNumber: 'No de projet',
  SiteLocation: 'Emplacement du site',
  SiteNumber: 'No de site',
  TaskOrder: 'No d’engagement',
  LineItem: 'No de ligne',
  CostObject: 'Objet de coût',
  ShelfLife: 'Conditions d’entreposage',
  RecordOfSiteCondition: 'Enregistrement de l’état du site',
  AuditSamples: 'Échantillons d’audit',
  DataPackage: 'Ensemble de données',
  SubmissionType: 'Type d’envoi',
  DeliveryAttention: 'Remettre à',
  Address: 'Adresse',
  Address2: 'Adresse 2',
  City: 'Ville',
  Province: 'Province / Etat',
  PostalCode: 'Code postal',
  Country: 'Pays',
  Cell: 'Cellulaire',
  TitleOfTemplate: 'Titre du modèle',
  UnlockTemplate: 'Enlever la protection',
  LockTemplate: 'Protéger le modèle',
  WaterworksNumber: 'No d’aqueduc',
  WaterworksName: 'Nom de l’aqueduc',
  ProjectInformation: 'Renseignements sur le projet',
  ShipTo: 'Envoyer à',
  ReportTo: 'Envoyer rapport à',
  'ALSO SEND REPORT TO': 'ENVOYER AUSSI À',
  WaterWorksTitle: 'Obligation de prévenir',
  WaterWorksInfo: 'Information sur l’aqueduc',
  'Get Info': 'Obtenir des informations',

  Supplies: 'Matériel',
  'Required By': 'Requis pour le',
  RequestedBy: 'Demandé par',
  ChangingSubmissionType: 'En modifiant le type d’envoi, cela réinitialisera l’information sur l’échantillon et les analyses. Voulez-vous continuer ?',
  DefaultOrderLocationInvoice: 'Votre laboratoire de Bureau Veritas par défaut est {{orderLocation}}',
  DefaultOrderLocationReport: 'Votre laboratoire de Bureau Veritas par défaut pour cette adresse du rapport est {{orderLocation}}',
  RequestedDate: 'Date de la demande',
  IsPrepaidClient: 'Il s’agit d’un client prépayé. Le flux de travail prépayé a été lancé.',
  Company: 'Nom de l’enterprise',
  Facility: 'Succursale',
  StreetAddress: 'Adresse',
  OverridePrepaidWorkflow: 'Remplacer le flux de travail',
  CreatePrepaidJob: 'Créer un travail prépayé',
  SelectShippingAddress: 'Sélectionnez  l’adresse de livraison',
  SiteLocationP: 'Emplacement du siteProvince',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/formsDetails.js